import { render, staticRenderFns } from "./RecordingPlayers.vue?vue&type=template&id=486bd75a&"
import script from "./RecordingPlayers.vue?vue&type=script&lang=js&"
export * from "./RecordingPlayers.vue?vue&type=script&lang=js&"
import style0 from "./RecordingPlayers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports